// @generated by protoc-gen-es v1.0.0 with parameter "target=js+dts,ts_nocheck=false"
// @generated from file api/billing_new/dto_order_new.proto (package com.diagnocat.billing_new, syntax proto3)
/* eslint-disable */

import { Empty, proto3, Timestamp } from "@bufbuild/protobuf";
import { CalledVia, Created, RevisionNew } from "../../model/dto_base_pb.js";
import { ProductModel, SubscriptionActivationLimitTrigger } from "./dto_product_new_pb.js";

/**
 *  List of scenarios that allow deleting a product state.
 *  Limit exhaustion alone is NOT a valid reason — it must be paired with
 *  activation of a new subscription (see LimitExhaustedWithReplacement).
 *
 * @generated from enum com.diagnocat.billing_new.EffectProductStateRemoveReasonCode
 */
export const EffectProductStateRemoveReasonCode = proto3.makeEnum(
  "com.diagnocat.billing_new.EffectProductStateRemoveReasonCode",
  [
    {no: 0, name: "EffectProductStateRemoveReasonCode_InvalidValue"},
    {no: 1, name: "EffectProductStateRemoveReasonCode_LimitExhaustedWithReplacement"},
    {no: 2, name: "EffectProductStateRemoveReasonCode_DiagnocatEmployeeError"},
    {no: 3, name: "EffectProductStateRemoveReasonCode_ReactivationByAgreement"},
    {no: 4, name: "EffectProductStateRemoveReasonCode_ContractTermination"},
    {no: 5, name: "EffectProductStateRemoveReasonCode_AutoReplacedOnLimitExhaustion"},
    {no: 6, name: "EffectProductStateRemoveReasonCode_ConfigurationTesting"},
  ],
);

/**
 *  Why a scheduled replacement became due. Derived from the source's own state
 *  at the moment of the swap, never from which worker happened to observe it
 *  first (WA-6427).
 *
 * @generated from enum com.diagnocat.billing_new.SubscriptionReplacementCause
 */
export const SubscriptionReplacementCause = proto3.makeEnum(
  "com.diagnocat.billing_new.SubscriptionReplacementCause",
  [
    {no: 0, name: "SubscriptionReplacementCause_InvalidValue"},
    {no: 1, name: "SubscriptionReplacementCause_LimitsExhausted"},
    {no: 2, name: "SubscriptionReplacementCause_SourceLifetimeEnded"},
    {no: 3, name: "SubscriptionReplacementCause_SourceRemoved"},
  ],
);

/**
 *  Why an admin removed coins.
 *
 * @generated from enum com.diagnocat.billing_new.EffectDiagnocoinAdjustmentReasonCode
 */
export const EffectDiagnocoinAdjustmentReasonCode = proto3.makeEnum(
  "com.diagnocat.billing_new.EffectDiagnocoinAdjustmentReasonCode",
  [
    {no: 0, name: "EffectDiagnocoinAdjustmentReasonCode_InvalidValue"},
    {no: 1, name: "EffectDiagnocoinAdjustmentReasonCode_DiagnocatEmployeeError"},
    {no: 2, name: "EffectDiagnocoinAdjustmentReasonCode_ReactivationByAgreement"},
    {no: 3, name: "EffectDiagnocoinAdjustmentReasonCode_ContractTermination"},
    {no: 4, name: "EffectDiagnocoinAdjustmentReasonCode_ConfigurationTesting"},
  ],
);

/**
 * @generated from message com.diagnocat.billing_new.Order
 */
export const Order = proto3.makeMessageType(
  "com.diagnocat.billing_new.Order",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "SequentialID", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "AccountID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "Effect", kind: "message", T: Effect },
    { no: 20, name: "Billed", kind: "message", T: Order_BilledOrderKind, oneof: "Kind" },
    { no: 21, name: "Service", kind: "message", T: Order_ServiceOrderKind, oneof: "Kind" },
    { no: 30, name: "Processed", kind: "message", T: Processed },
    { no: 10030, name: "Created", kind: "message", T: Created },
    { no: 10040, name: "Revision", kind: "message", T: RevisionNew },
    { no: 10050, name: "Deleted", kind: "message", T: OrderDeleted },
  ],
);

/**
 * @generated from message com.diagnocat.billing_new.Order.BilledOrderKind
 */
export const Order_BilledOrderKind = proto3.makeMessageType(
  "com.diagnocat.billing_new.Order.BilledOrderKind",
  () => [
    { no: 1, name: "Amount", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "DueDate", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "Invoiced", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "InvoiceID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "InvoiceURL", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "Paid", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "Cancelled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "Overdue", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 11, name: "TransactionNumber", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "MarkedAsPaid", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 13, name: "CustomPrice", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "Order_BilledOrderKind"},
);

/**
 * @generated from message com.diagnocat.billing_new.Order.ServiceOrderKind
 */
export const Order_ServiceOrderKind = proto3.makeMessageType(
  "com.diagnocat.billing_new.Order.ServiceOrderKind",
  [],
  {localName: "Order_ServiceOrderKind"},
);

/**
 * @generated from message com.diagnocat.billing_new.Effect
 */
export const Effect = proto3.makeMessageType(
  "com.diagnocat.billing_new.Effect",
  () => [
    { no: 1, name: "ProductStateRemove", kind: "message", T: EffectProductStateRemove, oneof: "Effect" },
    { no: 2, name: "UploadServiceSetLeftover", kind: "message", T: EffectUploadServiceSetLeftover, oneof: "Effect" },
    { no: 20, name: "SubscriptionAdd", kind: "message", T: EffectSubscriptionAdd, oneof: "Effect" },
    { no: 21, name: "SubscriptionRenew", kind: "message", T: EffectSubscriptionRenew, oneof: "Effect" },
    { no: 24, name: "SubscriptionSetAutoRenewal", kind: "message", T: EffectSubscriptionSetAutoRenewal, oneof: "Effect" },
    { no: 25, name: "SubscriptionSetAutoCharge", kind: "message", T: EffectSubscriptionSetAutoCharge, oneof: "Effect" },
    { no: 26, name: "SubscriptionReplacementActivate", kind: "message", T: EffectSubscriptionReplacementActivate, oneof: "Effect" },
    { no: 41, name: "PackageAdd", kind: "message", T: EffectPackageAdd, oneof: "Effect" },
    { no: 42, name: "DiagnocoinPurchase", kind: "message", T: EffectDiagnocoinPurchase, oneof: "Effect" },
    { no: 43, name: "DiagnocoinAdjustment", kind: "message", T: EffectDiagnocoinAdjustment, oneof: "Effect" },
  ],
);

/**
 * @generated from message com.diagnocat.billing_new.OrderDeleted
 */
export const OrderDeleted = proto3.makeMessageType(
  "com.diagnocat.billing_new.OrderDeleted",
  () => [
    { no: 1, name: "IsDeleted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "By", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "At", kind: "message", T: Timestamp },
    { no: 4, name: "Via", kind: "enum", T: proto3.getEnumType(CalledVia) },
    { no: 5, name: "IsDuplicate", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "DuplicateOfOrderID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.billing_new.Processed
 */
export const Processed = proto3.makeMessageType(
  "com.diagnocat.billing_new.Processed",
  () => [
    { no: 1, name: "By", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "At", kind: "message", T: Timestamp },
    { no: 3, name: "Via", kind: "enum", T: proto3.getEnumType(CalledVia) },
    { no: 4, name: "IsProcessed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "CreatedProductStateID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.billing_new.EffectProductStateRemove
 */
export const EffectProductStateRemove = proto3.makeMessageType(
  "com.diagnocat.billing_new.EffectProductStateRemove",
  () => [
    { no: 1, name: "RemoveProductStateID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Reason", kind: "enum", T: proto3.getEnumType(EffectProductStateRemoveReasonCode) },
    { no: 3, name: "Comment", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "ReplacementProductStateID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.billing_new.EffectUploadServiceSetLeftover
 */
export const EffectUploadServiceSetLeftover = proto3.makeMessageType(
  "com.diagnocat.billing_new.EffectUploadServiceSetLeftover",
  () => [
    { no: 1, name: "Upload2D", kind: "message", T: Empty, oneof: "ServiceGroupName" },
    { no: 2, name: "Upload3D", kind: "message", T: Empty, oneof: "ServiceGroupName" },
    { no: 3, name: "ProductStateID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Leftover", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message com.diagnocat.billing_new.EffectSubscriptionSetAutoRenewal
 */
export const EffectSubscriptionSetAutoRenewal = proto3.makeMessageType(
  "com.diagnocat.billing_new.EffectSubscriptionSetAutoRenewal",
  () => [
    { no: 1, name: "SubscriptionStateID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "IsAutoRenewal", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message com.diagnocat.billing_new.EffectSubscriptionSetAutoCharge
 */
export const EffectSubscriptionSetAutoCharge = proto3.makeMessageType(
  "com.diagnocat.billing_new.EffectSubscriptionSetAutoCharge",
  () => [
    { no: 1, name: "SubscriptionStateID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "IsAutoCharge", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message com.diagnocat.billing_new.EffectSubscriptionAdd
 */
export const EffectSubscriptionAdd = proto3.makeMessageType(
  "com.diagnocat.billing_new.EffectSubscriptionAdd",
  () => [
    { no: 1, name: "Subscription", kind: "message", T: ProductModel },
    { no: 2, name: "IsAutoRenewal", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "IsManualActivation", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "IsAutoCharge", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "StartAt", kind: "message", T: Timestamp },
    { no: 6, name: "ActivateOnLimitTrigger", kind: "enum", T: proto3.getEnumType(SubscriptionActivationLimitTrigger) },
  ],
);

/**
 * @generated from message com.diagnocat.billing_new.EffectSubscriptionRenew
 */
export const EffectSubscriptionRenew = proto3.makeMessageType(
  "com.diagnocat.billing_new.EffectSubscriptionRenew",
  () => [
    { no: 1, name: "RenewSubscriptionStateID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 *  EffectSubscriptionReplacementActivate is a RECEIPT, not an instruction
 *  (WA-6427). Billing writes it already processed, inside the same transaction
 *  that performs the swap, and never dispatches it through order processing.
 *
 *  It is deliberately absent from `CreateOrderReq`: a caller cannot construct
 *  one, so no validation guard is needed. Nothing else in the system may write
 *  it either — the activation it records is only ever decided by billing.
 *
 *  It replaces the `EffectProductStateRemove` +
 *  `AutoReplacedOnLimitExhaustion` pairing that recorded the exhaustion swap
 *  before, and unlike that pairing it is written on EVERY activation branch —
 *  including the ones that close no subscription at all, which previously left
 *  no trace in billing history whatsoever.
 *
 * @generated from message com.diagnocat.billing_new.EffectSubscriptionReplacementActivate
 */
export const EffectSubscriptionReplacementActivate = proto3.makeMessageType(
  "com.diagnocat.billing_new.EffectSubscriptionReplacementActivate",
  () => [
    { no: 1, name: "ActivatedProductStateID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "SourceProductStateID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "RemovedProductStateID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Cause", kind: "enum", T: proto3.getEnumType(SubscriptionReplacementCause) },
    { no: 5, name: "Trigger", kind: "enum", T: proto3.getEnumType(SubscriptionActivationLimitTrigger) },
  ],
);

/**
 * @generated from message com.diagnocat.billing_new.EffectPackageAdd
 */
export const EffectPackageAdd = proto3.makeMessageType(
  "com.diagnocat.billing_new.EffectPackageAdd",
  () => [
    { no: 1, name: "Package", kind: "message", T: ProductModel },
  ],
);

/**
 * EffectDiagnocoinPurchase credits a Diagnocoin batch to the account balance.
 *
 * Processing it creates exactly one batch, expiring one year after the moment
 * the order is processed. Unlike most effects this one is never deduplicated:
 * buying the same coin pack twice is legitimate and must credit twice.
 *
 * @generated from message com.diagnocat.billing_new.EffectDiagnocoinPurchase
 */
export const EffectDiagnocoinPurchase = proto3.makeMessageType(
  "com.diagnocat.billing_new.EffectDiagnocoinPurchase",
  () => [
    { no: 1, name: "Product", kind: "message", T: ProductModel },
  ],
);

/**
 * EffectDiagnocoinAdjustment takes available coins back out of ONE batch
 * (WA-6688). It only ever subtracts: coins are credited by purchases alone.
 *
 * Billing writes the order already processed, in the same transaction that moves
 * the coins, so a correction that failed leaves no order behind. Order
 * processing never dispatches it.
 *
 * Only coins that are spendable right now can be removed: the batch must be open
 * and unexpired, and `Amount` must not exceed its `Available`. Coins held by
 * pending reports are never touched.
 *
 * @generated from message com.diagnocat.billing_new.EffectDiagnocoinAdjustment
 */
export const EffectDiagnocoinAdjustment = proto3.makeMessageType(
  "com.diagnocat.billing_new.EffectDiagnocoinAdjustment",
  () => [
    { no: 1, name: "BatchID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "Reason", kind: "enum", T: proto3.getEnumType(EffectDiagnocoinAdjustmentReasonCode) },
    { no: 4, name: "Comment", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "RequestID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

